export default [
  'Contribute to Open Source or attend an Open Source Event',
  'Attend a sporting event with TMP',
  'Attend one new hire community building VTO activity',
  'Participate in a Hackday',
  'Get a Pluralsight License',
  'Submit a blog post to Salesforce Engineering',
  'Attend a TMP Wellness Event',
  'Become a SME for Bootcamp',
  'File a Patent',
  'Use Learn ++ to enroll in a clas',
  'Attend a Connect2Customer Event',
  'Log at least one volunteer hour',
  'Log at least one hour of PTOn!',
  'Use Qwikilabs',
  'Attend a Tech Talk',
  'Nominate someone for an All-Star Award',
  'Attend a Targeted Topics training',
  'Look through the openings in the Opportunity Open Market app',
  'Attend 1 Agile Class',
  'Speak at an external conference or meetup',
  'Attend TMP Movie Day',
  'Deliver a Tech Talk internally',
  'Follow @SalesforceEng on Twitter',
  'Take the Machine Learning trail on Trailhead',
];


// WEBPACK FOOTER //
// ./src/lib/WordPool.js